export const FacebookUrl = "https://bit.ly/3ZBzPDM";
export const InstagramUrl = "https://bit.ly/4gD8rw0";
export const YoutubeUrl = "https://bit.ly/4gCuWRz";
export const WhatsappUrl = "https://chat.whatsapp.com/DqY7ZA4NtZrJblCqNOd11O";
